module.exports = __webpack_public_path__ + "img/demo-carrot.cf63f152.svg";